import consolv from 'lib/consolv';

const defaultConfig = {
  magnitePrebid: {
    enabled: false,
    failsafeTimeout: 2000,
  },
};

function generateFirstPartyData(meta) {
  const data = {
    inventory: {
      topic: [],
    },
  };

  if (meta.page.topic) data.inventory.topic.push(meta.page.topic);
  return data;
}

/**
 * Creates the prebid request and callback that is called before loading slots
 * @param {MCPInstance} MCP
 * @param {Object} config
 */
const setupRequestBids = (MCP, config) => (event, { slots, addAsyncEvent, immediatelyLoad }) => {
  if (event === 'beforeAppendSlot' && !immediatelyLoad) return;

  const asyncEvent = new Promise((resolve) => {
    const { pbjs } = window;
    let failsafeTimerRef;

    /* eslint-disable-next-line prefer-arrow-callback */
    pbjs.que.push(function requestBids() {
      const slotMap = Array.from(slots.values())
        .filter(slot => slot.meta.allowPrebidBidding !== false);

      const gptSlotObjects = slotMap.map(slot => slot.DFPSlot);

      pbjs.rp.requestBids({
        callback: () => {
          window.clearTimeout(failsafeTimerRef);
          consolv.log('MCP: Magnite Prebid resolved');
          resolve();
        },
        gptSlotObjects,
        data: generateFirstPartyData(MCP.Configurator.meta),
      });
    });

    failsafeTimerRef = window.setTimeout(() => {
      const { failsafeTimeout } = config;
      consolv.log(`MCP: Magnite Prebid failsafe timeout exceeded at ${failsafeTimeout} seconds`);
      resolve();
    }, config.failsafeTimeout);
  });

  addAsyncEvent(asyncEvent);
};

/**
 * Generates the configuration and sets up event listeners for slot loads
 */
export default function MagnitePrebidAdapter(MCP) {
  if (!window.pbjs || !window.pbjs.que) { window.pbjs = { ...window.pbjs, que: [] }; }

  MCP.loaded.then(() => {
    const config = MCP.Configurator.getConfiguration({ defaults: defaultConfig }).magnitePrebid;

    if (config.enabled) {
      const requestBids = setupRequestBids(MCP, config);

      MCP.addEventListener('beforeLoadSlots',
        (...params) => requestBids('beforeLoadSlots', ...params));
      MCP.addEventListener('beforeAppendSlot',
        (...params) => requestBids('beforeAppendSlot', ...params));
      MCP.addEventListener('beforeRefreshSlots',
        (...params) => requestBids('beforeRefreshSlots', ...params));
    }
  });
}
